import { render } from "./QuickAddAgendaItem.vue?vue&type=template&id=13ea3163&scoped=true&ts=true"
import script from "./QuickAddAgendaItem.vue?vue&type=script&lang=ts"
export * from "./QuickAddAgendaItem.vue?vue&type=script&lang=ts"

import "./QuickAddAgendaItem.vue?vue&type=style&index=0&id=13ea3163&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ea3163"]])

export default __exports__